export default {
    API_URL: 'https://extranet-test.estravel.eu/api/',
    VUE_APP_ABOUT_PAGE_HTML_BASE_URL: 'https://extranet-test.estravel.eu/new_extranet/about-pages/',
    BASE_URL: 'https://extranet-test.estravel.eu/new_extranet/',
    AUTH_URL: 'https://auth-test.estravel.ee/oidc/endpoint/oidprovider/',
    AUTH_CLIENT_ID: 'extranet-front',
    AUTH_CLIENT_SECRET: '7up291inBR4T71QzcOgtt4UMboon0nEr',
    GA4_MEASUREMENT_ID: 'G-DD7WV7DEG4'
}
